import { render, staticRenderFns } from "./EditToolbar.vue?vue&type=template&id=ba8ffca6"
import script from "./EditToolbar.vue?vue&type=script&lang=js"
export * from "./EditToolbar.vue?vue&type=script&lang=js"
import style0 from "./EditToolbar.vue?vue&type=style&index=0&id=ba8ffca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports